<template>
  <v-layout row justify-center>
    <v-dialog v-model="controlDialogVisible"
      :max-width="width"
      :persistent="!closeWithMask"
      :fullscreen="fullscreen">
      <v-card>
        <v-card-title class="headline" v-if="showHead && ($slots.header || this.title)">
          <slot name="header">
            <p>{{ title }}</p>
          </slot>
        </v-card-title>
        <v-card-text>
          <slot>
            <p v-if="content">{{ content }}</p>
            <v-text-field :label="inputLabel"
              v-if="showInput"
              v-model="inputValue"
              @keyup.enter.native="closeDialog('ok')">
            </v-text-field>
          </slot>
        </v-card-text>
        <v-card-actions>
          <slot name="footer">
            <v-spacer></v-spacer>
            <v-btn flat v-if="showCancelButton" @click.native="closeDialog('cancel')">{{ localeCancelText }}</v-btn>
            <v-btn flat color="primary" v-if="showOkButton" @click.native="confirm('ok')">{{ localeOKText }}</v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import DialogMixin from '@/components/mixins/DialogMixin';

  export default {
    name: 'dialog-definitions',
    mixins: [DialogMixin],
    props: {
      title: String,
      content: String,
      cancelText: {
        type: String,
      },
      okText: {
        type: String,
      },
      showHead: {
        type: Boolean,
        default: true,
      },
      showClose: {
        type: Boolean,
        default: true,
      },
      showFooter: {
        type: Boolean,
        default: true,
      },
      showInput: {
        type: Boolean,
        default: false,
      },
      inputLabel: {
        type: String,
        default: '',
      },
      showCancelButton: {
        type: Boolean,
        default: true,
      },
      showOkButton: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        inputValue: null,
      };
    },
    computed: {
      /**
       * Metodo responsavel por retornar o texto.
       */
      localeOKText() {
        return (typeof this.okText === 'undefined') ? this.$t('global.ok') : this.okText;
      },
      /**
       * Metodo responsavel por retornar o texto.
       */
      localeCancelText() {
        return (typeof this.cancelText === 'undefined') ? this.$t('global.cancel') : this.cancelText;
      },
    },
    methods: {
      /**
       * Metodo responsavel por controlar o confirm do dialog
       */
      confirm() {
        if (this.showInput) {
          this.closeDialog('ok', { inputValue: this.inputValue });
        } else {
          this.closeDialog('ok');
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/plugins/dialog/DialogDefinitions.vue